<template>
  <div class="markets-wrapper">
    <div class="markets single" v-if="market">
      <div :class="['market', 'outright-market',
           {'suspended': !market.istradable },
           'selections-x' + market.selections.length,
           'col-x' + colNum,
           {'more-than-three-selections': market.selections.length > 3 }]"
           :idfomarket="market.idfomarket"
           :isfrompush="(market.V !== undefined).toString()">
        <div class="header">
          <div class="market-name">
            <h4 class="market-name-title text-overflow">{{ market.name}}</h4>
          </div>
        </div>

        <span v-if="isDebug" class="debug">
          {{ market.idfomarket }}<br />
          isfrompush {{ (market.V !== undefined).toString() }}
        </span>
        <div class="selections-container">
          <div class="selections non-had">
            <template v-if="market.isoutright">
              <div v-for="column in outrightSelectionsColumns" :class="['selection-col', 'no' + column]">
                <div class="static-selections">
                  <span :class="['selection', 'rotateindex' + selection.displaypage]"
                        v-for="selection in market.selections.filter(sel => sel.selectioncolumn === column && sel.displaypage === -1 && sel.idfoselectionsuspensiontype !== 'N/O')"
                        :key="selection.idfoselection">

                      <selection
                        :event="event"
                        :selection="selection"
                        :istradable="market.istradable"
                        :showselectionname="true"
                        :ishad="false"
                        :isoutright="true"
                        :fosportname="event.sportname"></selection>
                  </span>
                </div>
                <div ref="pagedselections" class="paged-selections" v-if="(column === 4 || column === 3) && scrollableSelections.length > 0">
                  <div class="pagedselections-clild" :style="{'top': currentScrollTop}">
                    <span :class="['selection', 'rotateindex' + selection.displaypage]"
                          ref="selection"
                          v-for="selection in scrollableSelections"
                          :key="selection.idfoselection">

                      <selection
                        :event="event"
                        :selection="selection"
                        :istradable="market.istradable"
                        :showselectionname="true"
                        :ishad="false"
                        :isoutright="true"
                        :fosportname="event.sportname"></selection>
                    </span>
                  </div>
                </div>
                <span v-if="showMoreSelectionsMessage && column === numOfOutrightSelectionsColumns" class="selection message">
                  See betting booths for more selections
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import lib from '@/library'

  import Vue from 'vue'
  import store from '@/store'

  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'
  import UrlParameters from '@/components/mixins/UrlParameters'

  import big3market from '@/components/bettingoffer/big3market'
  import selection from '@/components/bettingoffer/selection'

  export default {
    name: 'market',

    components: {
      selection,
      big3market
    },

    mixins: [
      Screen,
      BettingOffer,
      Brands,
      UrlParameters
    ],

    props: [
      'event',
      'islivepredefined',
      'is2displayhorizontally'
    ],

    data () {
      return {
        vue: Vue,
        clickTO: null,
        clickModal: null,
        action: null,
        selectionsPrices: {},
        panel: true,
        counter: 0
      }
    },

    computed: {
      market () {
        return this.event && this.event.outrightMarket
      },
      screenConfiguration () {
        return store.getters['cduState/getScreenConfiguration']
      },
      numOfOutrightSelectionsColumns () {
        return store.getters['bettingOfferState/getNumberOfOutrightTemplateColumns']
      },
      showMoreSelectionsMessage () {
        return store.getters['bettingOfferState/getShowMoreSelectionsMessage']
      },
      displaytemplate () {
        return this.$route.params.displaytemplate || 'standard'
      },
      outrightSelectionsColumns () {
        var columns = []
        for (let i = 0; i < this.numOfOutrightSelectionsColumns; i++) {
          columns.push(i + 1)
        }

        return columns
      },
      colNum () {
        if (this.outrightSelectionsColumns) {
          return this.outrightSelectionsColumns.length
        }
      },
      currentRotateIndex () {
        return store.getters['bettingOfferState/getCurrentRotateIndex']
      },
      maxRotationIndex () {
        return store.getters['bettingOfferState/getMaxRotationIndex']
      },
      currentScrollTop () {
        var selections = this.$refs['selection']
        var selection = null
        var selectionHeight = 0

        if (Array.isArray(selections)) {
          selection = selections[0]
        } else {
          if (selections) {
            selection = selections
          }
        }

        if (selection) {
          selectionHeight = lib.core.dom.elementOuterHeightIncludingMargins(selection)
        }

        return (this.currentRotateIndex * selectionHeight) * -1 + 'px'
      },
      scrollableSelections () {
        return Vue._.orderBy(this.market.selections, ['internalorder', 'decimalprice', 'name']).filter(sel => (sel.selectioncolumn === 4 || sel.selectioncolumn === 3) && sel.displaypage === 0 && sel.idfoselectionsuspensiontype !== 'N/O')
      },
      showparticipantlogo () {
        return this.current_brand_cnfiguration.showParticipantLogos
      }
    },

    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import '~@/css/config'
@import '~@/css/mixins'

  .paged-selections
    height 100%
    overflow hidden
    position relative

    .pagedselections-clild
      position absolute
      width 100%
      height: 100%
      transition top 0.7s

  .markets
  .market
  .markets-wrapper
    height: 100%

  .markets
    overflow hidden


    .market
      float left
      display: flex
      flex-direction: column

      &:last-child
        margin-right: 0

      .header
        text-align center
        flex: 0 0 unit(head-height, px)
        align-center()

      .selections-container
        flex: 1 1 auto
        display: flex

        .browser-internet-explorer.browser-version-11 &
          flex: 1 1 100%

      .selections
        overflow hidden

        .selection.outright
          border-right: solid 1px #000

          &:last-child
            border none

        .selection.message
          color: #fff
          padding-top: 20px
          text-transform: uppercase

      &.big3
        .selections
          flex-direction: column

          .selections
            height: 100%

        .selection
          float none
          flex: 0 0 50%

          &:first-child
            border-right: none

      &.outright-market
        .header
          display: none
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/outrightMarket.vue